import { render, staticRenderFns } from "./BranchDepositReport.vue?vue&type=template&id=538447e1&scoped=true"
import script from "./BranchDepositReport.vue?vue&type=script&lang=js"
export * from "./BranchDepositReport.vue?vue&type=script&lang=js"
import style0 from "./BranchDepositReport.vue?vue&type=style&index=0&id=538447e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538447e1",
  null
  
)

export default component.exports